export const useCreditsStore = defineStore('credits', () => {
  const creditInfo = ref<TNullable<TCreditInfo>>()
  const loading = ref(false)

  async function fetchCreditInfo () {
    loading.value = true

    try {
      const response = await creditsService.getCredits()
      creditInfo.value = response
    } finally {
      loading.value = false
    }
  }

  return {
    creditInfo,
    loading,
    fetchCreditInfo
  }
})
